import React from 'react';
import { bool, string, oneOf } from 'prop-types';
import cx from 'classnames';

const propTypes = {
  /** Error state. */
  isError: bool,
  /** Id for html for attribute. */
  id: string,
  /** Label size. */
  size: oneOf(['small', 'large']),
};

const CLASS_ROOT = 'form-label';

const Label = ({ className, children, id, isError, size, ...other }) => {
  const classes = cx(
    CLASS_ROOT,
    {
      [`${CLASS_ROOT}--${size}`]: size,
      'is-error': isError,
    },
    className
  );

  return (
    <div className={classes}>
      <label htmlFor={id} {...other}>
        {children}
      </label>
    </div>
  );
};

Label.displayName = 'Label';
Label.propTypes = propTypes;

export default Label;



// WEBPACK FOOTER //
// ./src/components/Forms/Label/Label.js